// Material-UI
import Box from '@mui/material/Box';

import { FypBannerItem } from '@creoate/virgo-content-api';

// Components
import BannerCard from './BannerCard';

interface BannerCarouselProps {
  banners?: FypBannerItem[];
}

const BannerCarousel = ({ banners = [] }: BannerCarouselProps) => {
  const bannerStyle = {
    display: 'flex',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    gap: '5px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  };

  return (
    <Box sx={{ pl: 0.5, mt: 1.5, ...bannerStyle }}>
      {banners?.map((banner, i) => (
        <Box data-testid={`fyp-banner-slider-${i}`} key={banner?.id}>
          <BannerCard testId={i} banner={banner} />
        </Box>
      ))}
    </Box>
  );
};

export default BannerCarousel;
